import { axiosService } from './axiosService';
import { RangeValue, RANGE_QUERY } from '../constants/product.constant';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

// Map a range token to its query string (?hours=N / ?days=N / ?days=all).
const q = (range: RangeValue) => `?${RANGE_QUERY[range]}`;

export const analyticsService = {
  // user-service
  getOverview: (days: RangeValue) => unwrap(auth().get(`user/analytics/overview${q(days)}`)),
  getSuperPrepUsers: (days: RangeValue) => unwrap(auth().get(`user/analytics/super-prep${q(days)}`)),
  getSuperCoach: (days: RangeValue) => unwrap(auth().get(`user/analytics/super-coach${q(days)}`)),
  getTeacherApp: (days: RangeValue) => unwrap(auth().get(`user/analytics/teacher-app${q(days)}`)),
  // Recent signups list — fixed to the last 2 days on the backend.
  getRecentSignups: () => unwrap(auth().get('user/analytics/recent-signups')),

  // assessment-service
  getTestAttempts: (days: RangeValue) => unwrap(auth().get(`assessment/analytics/admin/test-attempts${q(days)}`)),
  getTimeOnTest: (days: RangeValue) => unwrap(auth().get(`assessment/analytics/admin/time-on-test${q(days)}`)),

  // cms-service
  getFeedEngagement: (days: RangeValue) => unwrap(auth().get(`cms/analytics/admin/feed-engagement${q(days)}`)),

  // test accounts manager (user-service)
  listTestAccounts: () => unwrap(auth().get('user/analytics/test-accounts')),
  addTestAccount: (payload: { mobile?: string; email?: string; label?: string }) =>
    unwrap(auth().post('user/analytics/test-accounts', payload)),
  deleteTestAccount: (id: string) => unwrap(auth().delete(`user/analytics/test-accounts/${id}`)),
};
